<template>
  <div class="aval-wrapper">

      <div class="aval-labels">
          <span>{{ monthLabel("currentMonth") }}</span>
          <span>{{ monthLabel("previousMonth") }}</span>
      </div>
      <div class="aval-group">

          <StatBadge
            label="Ind."
            size="sm"
            variant="blue"
            :value="display('currentMonth', 'individual')"
            tooltip="Avaliações individuais (mês atual)"
          />
          <StatBadge
            label="Colet."
            size="sm"
            variant="orange"
            :value="display('currentMonth', 'coletive')"
            tooltip="Avaliações coletivas (mês atual)"
          />

          <StatBadge
            label="Ind."
            size="sm"
            variant="blue"
            :value="display('previousMonth', 'individual')"
            tooltip="Avaliações individuais (mês anterior)"
          />
          <StatBadge
            label="Colet."
            size="sm"
            variant="orange"
            :value="display('previousMonth', 'coletive')"
            tooltip="Avaliações coletivas (mês anterior)"
          />

      </div>



  </div>
</template>

<script>
import StatBadge from "@/components/table/StatBadge.vue";

/**
 * TeacherEvaluationsCell
 *
 * Célula de tabela que resume as avaliações individuais/coletivas do
 * mês atual e anterior de um professor. Específico do domínio de
 * professores — por isso vive junto da feature, não em `components/table`.
 *
 * `evaluations` pode vir `null`/incompleto (professor sem avaliações no
 * período, chave ausente na API) — cada nível é checado antes de
 * acessar, exibindo "—" na falta do dado em vez de quebrar.
 */
export default {
  name: "TeacherEvaluationsCell",

  components: { StatBadge },

  props: {
    /** `teacher.lastEvaluationsDates` — pode ser null/undefined/parcial. */
    evaluations: {
      type: Object,
      default: null,
    },
  },

  computed: {
    hasCurrentMonth() {
      return Boolean(this.monthData("currentMonth"));
    },

    hasPreviousMonth() {
      return Boolean(this.monthData("previousMonth"));
    },
  },

  methods: {
    monthData(monthKey) {
      return (this.evaluations && this.evaluations[monthKey]) || null;
    },

    count(monthKey, kind) {
      const data = this.monthData(monthKey);
      const value = data && data.byUrl ? data.byUrl[kind] : null;
      return value === undefined || value === null ? null : value;
    },

    display(monthKey, kind) {
      const value = this.count(monthKey, kind);
      return value === null ? "—" : value;
    },

    monthLabel(monthKey) {
      const data = this.monthData(monthKey);
      const period = data ? data.period : null;
      if (!period) {
        return "";
      }

      const parts = period.split("-");
      const formatted =
        parts.length === 2 ? `${parts[1]}/${parts[0]}` : period;
      return `(${formatted})`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.aval-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.aval-labels {
  display: flex;
  justify-content: space-around;
  font-size: 11px;
  font-weight: 700;
  color: $grey4;
  padding-left: 2px;
}

.aval-group {
  display: flex;
  gap: 6px;
}

.aval-empty {
  color: $grey5;
  font-size: 14px;
}
</style>
